export const ADMIN = 'ADMIN';
export const USER = 'USER'